<template>
  <div class="p-4">
    <h1 class="text-center">فاکتور شماره {{ order.id }}</h1>
    <hr class="border-brand my-4">

    <!--    Factor Detail -->
    <div class="border rounded-lg p-2 bg-gray-50 text-xs">
      <div class="grid grid-cols-2 gap-y-4">

        <div class="flex items-center">
          <OfficeBuildingIcon class="h-6 w-6 text-brand"/>
          <span class="mr-2" v-if="order.room">
            اتاق:
            {{ order.room.number }}
          </span>
        </div>

        <div class="flex items-center">
          <ClockIcon class="h-6 w-6 text-brand"/>
          <span class="mr-2">
            تاریخ:
            {{ order.created_at }}
          </span>
        </div>
      </div>
    </div>

    <!--    Payment Status -->
    <div class="bg-gray-800 p-4 rounded-lg mt-4 text-white">
      <div class="flex justify-between">
        <span class="">مبلغ قابل پرداخت:</span>
        <div class="text-center">
          <span class="text-green-500">{{ $helper.priceFormatter(order.total_price) }}</span>
          <div class="text-xs mt-1" :class="renderPaymentStatusClass()">{{ renderPaymentStatus() }}</div>
        </div>
      </div>
      <div class="text-xs text-red-500" v-if="order.payment_status === 'canceled'">{{ order.error }}</div>
      <div class="text-xs" v-if="order.payment_status === 'paid'">کد پیگیری: {{ order.reference_id }}</div>
    </div>

    <!--    Products -->
    <h1 class="mt-4">محصولات</h1>
    <OrderProductCard v-for="item in order.items"
                      :key="item.id"
                      :item="item"/>
  </div>

  <VButton class="w-full flex justify-center" v-if="order.payment_status !== 'paid'"
           @click="rePayment" :disabled="paymentLoading">
    <LoadingSpinner class="w-6 ml-2 !text-gray-500" v-if="paymentLoading"/>
    پرداخت
  </VButton>
</template>

<script>
import {getOrderDetail, getOrderRePayment} from "@/API/API";
import {ClockIcon, OfficeBuildingIcon} from "@heroicons/vue/outline";
import OrderProductCard from "@/components/User/OrderProductCard";
import VButton from "@/components/General/VButton";
import LoadingSpinner from "@/components/General/LoadingSpinner";

export default {
  name: "OrderDetail",
  components: {
    LoadingSpinner,
    VButton,
    OfficeBuildingIcon,
    ClockIcon,
    OrderProductCard
  },
  data() {
    return {
      order: {},
      paymentLoading: false
    }
  },
  async created() {
    this.order = (await getOrderDetail(this.$route.params.id)).data

    let comeFromBank = this.$route.query.bank
    if (comeFromBank) {
      this.$swal({
        icon: 'success',
        title: 'موفق',
        text: 'پرداخت شما با موفقیت انجام شد.',
        confirmButtonColor: '#fcd34d',
        confirmButtonText: 'باشه'
      })
    }
  },
  methods: {
    renderPaymentStatusClass() {
      switch (this.order.payment_status) {
        case 'pending':
          return 'text-yellow-500'
        case 'paid':
          return 'text-green-500'
        case 'canceled':
          return 'text-red-500'
      }
    },
    renderPaymentStatus() {
      switch (this.order.payment_status) {
        case 'pending':
          return '(در انتظار)'
        case 'paid':
          return '(پرداخت شده)'
        case 'canceled':
          return '(لغو شده)'
      }
    },
    async rePayment() {
      this.paymentLoading = true
      let resp = (await getOrderRePayment(this.$route.params.id)).data
      this.paymentLoading = false
      window.location.href = resp.action;
    }
  }
}
</script>

<style scoped>

</style>